var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.766,
    height: 12.804,
    viewBox: "0 0 13.766 13.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M9.21,7.121l4.85-4.887a.541.541,0,0,0,0-.783L13.314.667a.541.541,0,0,0-.783,0L7.643,5.554a.361.361,0,0,1-.522,0L2.234.629a.541.541,0,0,0-.783,0l-.783.783a.541.541,0,0,0,0,.783L5.554,7.084a.361.361,0,0,1,0,.522L.629,12.531a.541.541,0,0,0,0,.783l.783.783a.541.541,0,0,0,.783,0L7.084,9.21a.361.361,0,0,1,.522,0L12.493,14.1a.541.541,0,0,0,.783,0l.783-.783a.541.541,0,0,0,0-.783L9.21,7.643A78.83,78.83,0,0,1,5.554.629Z",
    transform: "translate(-0.462 -0.462)",
    fill: "#98a1a9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.6aa09995618004eef3cc005b69b1df9c.svg";
export { ForwardRef as ReactComponent };